module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "4"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    staticClass: "ml-2 mr-2",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('h5', {
    staticClass: "mt-1 mr-2"
  }, [_vm._v("\n            " + _vm._s(_vm.$route.name) + "\n          ")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalData) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    class: ' ml-4' + _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": _vm.Filter.DateTypeFilter ||
        _vm.Filter.ModuleTypeFilter ||
        _vm.Filter.PaymentTypeFilter ||
        _vm.Filter.JobNoFilter ||
        _vm.Filter.TransactionNoFilter ||
        _vm.Filter.clientFilter ||
        _vm.Filter.slineFilter ||
        _vm.Filter.TransportTypeFilter ||
        _vm.Filter.ShipemntTypeFilter ||
        _vm.Filter.PORFilter ||
        _vm.Filter.POLFilter ||
        _vm.Filter.PODFilter ||
        _vm.Filter.FPODFilter ||
        _vm.Filter.statusFilter ||
        _vm.Filter.commonFilter ||
        _vm.Filter.createdByFilter ||
        _vm.Filter.approverByFilter ||
        _vm.Filter.branchFilter ||
        _vm.Filter.dateRange.startDate ||
        _vm.Filter.dateRange.endDate ?
        'outline-danger' :
        'outline-primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v(_vm._s(_vm.Filter.DateTypeFilter ||
    _vm.Filter.ModuleTypeFilter ||
    _vm.Filter.PaymentTypeFilter ||
    _vm.Filter.JobNoFilter ||
    _vm.Filter.TransactionNoFilter ||
    _vm.Filter.clientFilter ||
    _vm.Filter.slineFilter ||
    _vm.Filter.TransportTypeFilter ||
    _vm.Filter.ShipemntTypeFilter ||
    _vm.Filter.PORFilter ||
    _vm.Filter.POLFilter ||
    _vm.Filter.PODFilter ||
    _vm.Filter.FPODFilter ||
    _vm.Filter.statusFilter ||
    _vm.Filter.commonFilter ||
    _vm.Filter.createdByFilter ||
    _vm.Filter.approverByFilter ||
    _vm.Filter.branchFilter ||
    _vm.Filter.dateRange.startDate ||
    _vm.Filter.dateRange.endDate ?
    "Filter ON" :
    "Filter OFF"))]), _vm._v(" "), (_vm.paymentList.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('getPaymentList', 'Export As Excel')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.paymentList.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.exportApprovalToExcelClient
    }
  }, [_vm._v("\n            Export (Client XLSX)\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])], 1), _vm._v(" "), (_vm.visible) ? _c('div', [_c('b-card', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.dateTypeList,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Date Type"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.DateTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "DateTypeFilter", $$v)
      },
      expression: "Filter.DateTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale,
      "disabled": _vm.Filter.DFlag ? true : false
    },
    on: {
      "update": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "dateRange", $$v)
      },
      expression: "Filter.dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Module Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.moduleOptions,
      "option-value": "Val",
      "option-text": "Text",
      "placeholder": "Select Module Type"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.ModuleTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "ModuleTypeFilter", $$v)
      },
      expression: "Filter.ModuleTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Payment Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.payTypeOptions,
      "option-value": "Val",
      "option-text": "Text",
      "placeholder": "Select Payment Type"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.PaymentTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PaymentTypeFilter", $$v)
      },
      expression: "Filter.PaymentTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.statusList,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Status"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.statusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "statusFilter", $$v)
      },
      expression: "Filter.statusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Job NO Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Job NO Filter",
      "id": "JobNoFilter",
      "name": "JobNoFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.JobNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "JobNoFilter", $$v)
      },
      expression: "Filter.JobNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Transaction No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Transaction No Filter",
      "id": "TransactionNoFilter",
      "name": "TransactionNoFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.TransactionNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "TransactionNoFilter", $$v)
      },
      expression: "Filter.TransactionNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Transport Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.transportTypeList,
      "option-value": "value",
      "option-text": "value",
      "placeholder": "Select Transport Type"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.TransportTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "TransportTypeFilter", $$v)
      },
      expression: "Filter.TransportTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipment Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.shipmentTypeList,
      "option-value": "value",
      "option-text": "value",
      "placeholder": "Select Shipment Type"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.ShipemntTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "ShipemntTypeFilter", $$v)
      },
      expression: "Filter.ShipemntTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.slineFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "slineFilter", $$v)
      },
      expression: "Filter.slineFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientFilter",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.clientFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientFilter", $$v)
      },
      expression: "Filter.clientFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.branchFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchFilter", $$v)
      },
      expression: "Filter.branchFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POR")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPORList'],
      "id": "PORFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.PORFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PORFilter", $$v)
      },
      expression: "Filter.PORFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POL")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPOLList'],
      "id": "POLFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.POLFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "POLFilter", $$v)
      },
      expression: "Filter.POLFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPODList'],
      "id": "PODFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.PODFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PODFilter", $$v)
      },
      expression: "Filter.PODFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("FPOD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllLocationDetailsFinalList'],
      "id": "FPODFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.FPODFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "FPODFilter", $$v)
      },
      expression: "Filter.FPODFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Common Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Common Filter",
      "id": "commonFilter",
      "name": "commonFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.commonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "commonFilter", $$v)
      },
      expression: "Filter.commonFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v(" Created User ")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "createdByFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.createdByFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "createdByFilter", $$v)
      },
      expression: "Filter.createdByFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v(" Approver User ")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "approverByFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Approver User"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.approverByFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "approverByFilter", $$v)
      },
      expression: "Filter.approverByFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    ref: "scrollArea",
    staticClass: "table-responsive tableMain gutr",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "items": _vm.paymentList,
      "fields": _vm.PaymentFields,
      "primary-key": "id_email_section",
      "per-page": _vm.pagination.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "checkbox",
      fn: function(row0) {
        return [_c('div', {
          staticClass: "d-flex align-items-center gap-2"
        }, [_c('b-button', {
          staticClass: "mr-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "xs",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.onToggleDetails(row0)
            }
          }
        }, [_c('md-icon', [_vm._v(_vm._s(row0.detailsShowing ? "expand_less" : "expand_more"))]), _vm._v("\n                    " + _vm._s(row0.detailsShowing ? "Hide More" : "Show More") + "\n                  ")], 1), _vm._v(" "), _c('b-form-checkbox', {
          attrs: {
            "value": {
              ApeId: row0.item.fk_ape_id,
              JobId: row0.item.JobId,
              JobNo: row0.item.JobNo,
              TransactionNo: row0.item.TransactionNo,
            }
          },
          model: {
            value: (_vm.selectedCheckBoxRows),
            callback: function($$v) {
              _vm.selectedCheckBoxRows = $$v
            },
            expression: "selectedCheckBoxRows"
          }
        })], 1)]
      }
    }, {
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v("\n                  " + _vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage) + "\n                ")])]
      }
    }, {
      key: "TransDet",
      fn: function(row1) {
        return [_c('strong', [_vm._v("Trans No:")]), _vm._v(" " + _vm._s(row1.item.TransactionNo)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Status:")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row1.item.approval_status === 'APPROVED' ? 'success' : (row1.item.approval_status === 'REJECTED' ? 'danger' : 'warning')
          }
        }, [_vm._v("\n                  " + _vm._s(row1.item.approval_status || '-') + "\n                ")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Requested:")]), _vm._v(" " + _vm._s(row1.item.approval_requested_at || '-') + "\n                "), (_vm.$sessionsStorage.get('is_Mobile') != 'port') ? _c('Assignment-Summary', {
          attrs: {
            "title": 'Shipment Summary Tracking - ',
            "assign_date": row1.item.JobDate,
            "assign_job_type": row1.item.JobType,
            "assign_raised_from": 'Raised From: ' + row1.item.JobRaisedFrom,
            "assign_raised_by": 'Raised By: ' + row1.item.raisedBy,
            "fk_all_module_id": row1.item.JobId,
            "jb_series": row1.item.JobNo,
            "fk_client_id": '',
            "fk_pod_id": ''
          }
        }) : _vm._e(), _vm._v(" "), (_vm.$sessionsStorage.get('is_Mobile') != 'port') ? _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(row1.item)
            }
          }
        }, [_vm._v("Summary &\n                  Documents")]) : _vm._e()]
      }
    }, {
      key: "JobDet",
      fn: function(row1) {
        return [_c('strong', [_vm._v("Job No:")]), _vm._v(" " + _vm._s(row1.item.JobNo)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Job Date:")]), _vm._v(" " + _vm._s(row1.item.JobDate)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Raised By:")]), _vm._v(" " + _vm._s(row1.item.JobRaisedBy)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Raised From:")]), _vm._v(" " + _vm._s(row1.item.JobRaisedFrom)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Type:")]), _vm._v(" " + _vm._s(row1.item.ModuleType) + " / " + _vm._s(row1.item.JobType) + "\n                "), (row1.item.JobId) ? _c('AssignmentSplitMergeSummary', {
          attrs: {
            "PMC_title": 'Assignment Split/Merge/Move Summary Job No - ' + row1.item.JobNo,
            "PMC_JOBID": String(row1.item.JobId),
            "PMC_JOBNO": row1.item.JobNo,
            "PMC_JOBDATE": row1.item.JobDate,
            "PMC_JOBTYPE": row1.item.JobType,
            "PMC_AgentType": '',
            "PMC_Client": row1.item.Client,
            "PMC_Sline": row1.item.Sline
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.JobId) ? _c('JobWisePaymentsDetails', {
          attrs: {
            "allModuleId": Number(row1.item.JobId),
            "JobNo": row1.item.JobNo
          }
        }) : _vm._e()]
      }
    }, {
      key: "LocDet",
      fn: function(row1) {
        return [(row1.item.POR) ? _c('span', [_vm._v("POR:" + _vm._s(row1.item.POR)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.POL) ? _c('span', [_vm._v("POL:" + _vm._s(row1.item.POL)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.POD) ? _c('span', [_vm._v("POD:" + _vm._s(row1.item.POD)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.FPOD) ? _c('span', [_vm._v("FPOD:" + _vm._s(row1.item.FPOD)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.PICK) ? _c('span', [_vm._v("PICK:" + _vm._s(row1.item.PICK)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.HAND) ? _c('span', [_vm._v("HAND:" + _vm._s(row1.item.HAND)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.STUFF) ? _c('span', [_vm._v("STUFF:" + _vm._s(row1.item.STUFF)), _c('br')]) : _vm._e()]
      }
    }, {
      key: "PayDet",
      fn: function(row1) {
        return [(row1.item.inv_amt) ? _c('span', [_vm._v("Inv Amt:" + _vm._s(row1.item.inv_amt)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.currencyCode) ? _c('span', [_vm._v("Currency:" + _vm._s(row1.item.currencyCode)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.ledger) ? _c('span', [_vm._v("Particulars:" + _vm._s(row1.item.ledger)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.nature_name) ? _c('span', [_vm._v("NOE:" + _vm._s(row1.item.nature_name)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.sc_category) ? _c('span', [_vm._v("Bill of Shipper:" + _vm._s(row1.item.sc_category)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.selling_amt) ? _c('span', [_vm._v("Selling Amt:" + _vm._s(row1.item.selling_amt)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.inv_doc) ? _c('div', [_vm._l((row1.item.inv_doc.split(',')), function(doc, idx) {
          return _c('span', {
            key: idx,
            staticClass: "d-inline-block mb-1"
          }, [_c('b-button', {
            staticStyle: {
              "font-size": "0.675rem"
            },
            attrs: {
              "size": "xs",
              "variant": "warning",
              "href": ("" + _vm.docURL + (doc.trim())),
              "target": "_blank",
              "rel": "noopener"
            }
          }, [_vm._v("\n                      View Doc " + _vm._s(row1.item.inv_doc.includes(',') ? idx + 1 : '') + "\n                    ")])], 1)
        }), _vm._v(" "), _c('br')], 2) : _vm._e()]
      }
    }, {
      key: "row-details",
      fn: function(row4) {
        return [_c('b-card', {
          staticStyle: {
            "background": "whiteSmoke"
          }
        }, [_c('b-row', [(row4.item._childrenLoading) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "cols": "12"
          }
        }, [_c('span', [_vm._v("Loading child items...")])]) : _vm._e(), _vm._v(" "), ((row4.item.children && row4.item.children.length) || (row4.item.getItems && row4.item.getItems.length)) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "cols": "12"
          }
        }, [(String(row4.item.payment_type).toLowerCase() === 'expense') ? _c('b-table', {
          attrs: {
            "small": "",
            "items": row4.item.children && row4.item.children.length ? row4.item.children : (row4.item.getItems || []),
            "fields": [{
                key: 'inv_date',
                label: 'Inv Date'
              },
              {
                key: 'nature_of_expense_relation.nature_name',
                label: 'NOE'
              },
              {
                key: 'sc_remark',
                label: 'Remarks'
              }
            ],
            "head-variant": "light"
          },
          scopedSlots: _vm._u([{
            key: "cell(inv_doc_url)",
            fn: function(c) {
              return [(c.item && c.item.inv_doc_url) ? _c('div', [_c('b-button', {
                staticStyle: {
                  "font-size": "0.675rem"
                },
                attrs: {
                  "size": "xs",
                  "variant": "warning",
                  "href": String(c.item.inv_doc_url).startsWith('http') ? c.item.inv_doc_url : ("" + _vm.docURL + (c.item.inv_doc_url)),
                  "target": "_blank",
                  "rel": "noopener"
                }
              }, [_vm._v("\n                              View Doc\n                            ")])], 1) : _c('div', [_vm._v("-")])]
            }
          }])
        }) : (String(row4.item.payment_type).toLowerCase() === 'additional task') ? _c('b-table', {
          attrs: {
            "small": "",
            "items": row4.item.children && row4.item.children.length ? row4.item.children : (row4.item.getItems || []),
            "fields": [{
                key: 'inv_date',
                label: 'Inv Date'
              },
              {
                key: 'inv_amt',
                label: 'Inv AMT'
              },
              {
                key: 'ledgermaster_relation.ledger',
                label: 'Particular'
              },
              {
                key: 'master_currency_relation.currencyCode',
                label: 'Currency'
              },
              {
                key: 'sc_category',
                label: 'Bill To Customer'
              },
              {
                key: 'selling_amt',
                label: 'Selling AMT'
              },
              {
                key: 'sc_remark',
                label: 'Remarks'
              }
            ],
            "head-variant": "light"
          }
        }) : _vm._e()], 1) : _vm._e()], 1)], 1)]
      }
    }, {
      key: "PeopleDet",
      fn: function(row1) {
        return [_c('strong', [_vm._v("Requester:")]), _vm._v(" " + _vm._s(row1.item.requestBy || '-')), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Approver:")]), _vm._v(" " + _vm._s(row1.item.approverBy || '-') + "\n\n                "), (row1.item.JobId) ? _c('InvExpSummary', {
          attrs: {
            "PMC_title": 'Inv Exp Summary Job No - ' + row1.item.JobNo,
            "PMC_JOBID": String(row1.item.JobId),
            "PMC_JOBNO": row1.item.JobNo,
            "PMC_JOBDATE": row1.item.JobDate,
            "PMC_JOBTYPE": row1.item.JobType,
            "PMC_AgentType": '',
            "PMC_Client": row1.item.Client,
            "PMC_Sline": row1.item.Sline
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.JobId) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row1.item.JobNo,
            "PMC_JOBID": String(row1.item.JobId),
            "PMC_JOBNO": row1.item.JobNo,
            "PMC_JOBDATE": row1.item.JobDate,
            "PMC_JOBTYPE": row1.item.JobType,
            "PMC_AgentType": '',
            "PMC_Client": row1.item.Client,
            "PMC_Sline": row1.item.Sline
          }
        }) : _vm._e()]
      }
    }, {
      key: "TimeDet",
      fn: function(row1) {
        return [_c('strong', [_vm._v("Requested:")]), _vm._v(" " + _vm._s(row1.item.approval_requested_at || '-')), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Acted:")]), _vm._v(" " + _vm._s(row1.item.acted_at || '-')), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Completed:")]), _vm._v(" " + _vm._s(row1.item.approval_completed_at || '-') + "\n              ")]
      }
    }, {
      key: "actions",
      fn: function(row1) {
        return [_c('div', {
          staticClass: "d-flex align-items-center justify-content-end"
        }, [(row1.item.approval_status === 'PENDING' || row1.item.approval_status === 'REJECTED' || row1.item.approval_status === 'CANCELLED') ? _c('b-dropdown', {
          attrs: {
            "right": "",
            "variant": _vm.isPending(row1.item) ? 'warning' : (_vm.isRejectedOrCancelled(row1.item) ? 'secondary' : 'outline-secondary'),
            "size": "sm",
            "toggle-class": "btn-xs rounded-pill px-2"
          }
        }, [(row1.item.approval_status === 'PENDING') ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.openAction(row1.item, 'APPROVE')
            }
          }
        }, [_vm._v("Approve")]) : _vm._e(), _vm._v(" "), (row1.item.approval_status === 'PENDING') ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.openAction(row1.item, 'REJECT')
            }
          }
        }, [_vm._v("Reject")]) : _vm._e(), _vm._v(" "), (row1.item.approval_status === 'PENDING') ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.openAction(row1.item, 'CANCEL')
            }
          }
        }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), (row1.item.approval_status === 'REJECTED' || row1.item.approval_status === 'CANCELLED') ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.openAction(row1.item, 'RESEND')
            }
          }
        }, [_vm._v("Resend")]) : _vm._e()], 1) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _c('div', {
    ref: "infiniteSentinel",
    staticStyle: {
      "height": "1px"
    }
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "approval-action-modal",
      "title": _vm.actionModal.title,
      "hide-footer": ""
    },
    model: {
      value: (_vm.actionModal.show),
      callback: function($$v) {
        _vm.$set(_vm.actionModal, "show", $$v)
      },
      expression: "actionModal.show"
    }
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitAction($event)
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Remark / Reason"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "4",
      "max-rows": "6",
      "placeholder": "Enter reason (required)"
    },
    model: {
      value: (_vm.actionModal.remark),
      callback: function($$v) {
        _vm.$set(_vm.actionModal, "remark", $$v)
      },
      expression: "actionModal.remark"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": function($event) {
        _vm.actionModal.show = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary",
      "type": "submit",
      "disabled": !_vm.actionModal.remark || _vm.isLoading
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isLoading ? 'Please wait...' : 'Submit') + "\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": 'Assignment Summary & Documents - ' + _vm.JOBSERIES
    }
  }, [(_vm.ALLMODULE) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n    ")])], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0b9cc58","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/payment/PaymentApprovalList.vue
// module id = 2837
// module chunks = 0